export type WebPushPayload = {
  data?: Record<string, string>;
  notification?: {
    body?: string;
    title?: string;
  };
};

export function getWebPushNotificationShowOptions(payload: WebPushPayload) {
  const data = payload.data ?? {};
  const title = payload.notification?.title ?? data.title ?? '';
  const body = payload.notification?.body ?? data.body ?? '';

  return {
    options: {
      body,
      data,
      tag: data.notification_id,
    },
    title,
  };
}
